import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";

@Component({ name: "NewsletterSubscribe" })
export default class NewsletterSubscribe extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public newAccount: boolean = false;
    public isNewsletterInterestsVisible: boolean = false;
    public interests: any[] = [];
    public countries: any[] = [];
    public languages: any[] = [];
    public subscribeData: any = null;
    public formData: any = { profileSegment: null, country: null, language: null };
    public profileSegments: any[] = [];
    public validationErrors: any[] = [];
    public dataRow: string = "1";

    get isNewsletterSubscribeVisible() {
        return this.$store.getters["newsletterStore/isNewsletterSubscribeVisible"];
    }

    get newsletterSubscribeData() {
        return this.$store.getters["newsletterStore/newsletterSubscribeData"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly hcaptchaSiteKey: string;
    @Prop() readonly hcaptchaUrl: string;
    @Prop() readonly urlPrivacyPolicy: string;
    @Prop() readonly countryCode: string;

    @Watch("isNewsletterSubscribeVisible") async onInfoRequestVisibilityUpdate(newValue: boolean) {
        if (newValue) {
            await Promise.all([this.getData(), this.getCountries()]);
            this.setRecapthca();

            document.body.classList.add("overflow");
            (<any>this).$refs.newsletterSubscribeModal.classList.add("show");
        } else {
            document.body.classList.remove("overflow");
            (<any>this).$refs.newsletterSubscribeModal.classList.remove("show");
        }
    }

    public async created() {
        this.setOpenNewsletterDialog();
    }

    public setRecapthca() {
        let hcaptchaScript = document.createElement("script");
        hcaptchaScript.setAttribute("src", this.hcaptchaUrl);
        document.head.appendChild(hcaptchaScript);
    }

    public async getData() {
        this.subscribeData = (await Axios.post(this.routes.Newsletter_GetNewsletterSubscribeData, null)).data;
        this.formData.interests = this.subscribeData.interests.map(x => x.value);
        this.profileSegments = this.subscribeData.profileSegments;
        this.interests = this.subscribeData.interests;
    }

    public async getCountries() {
        const result = (await Axios.post(this.routes.Geo_GetCountries)).data;
        this.countries = result;

        this.formData.country = this.countries.find(x => x.code === this.countryCode)?.code;
        this.onCountrySelect();
    }

    public onCountrySelect() {
        let selectedLanguage = [];
        this.languages = [];
        if (this.formData.country) {
            for (const country of this.countries) {
                if (country.code === this.formData.country) {
                    selectedLanguage.push(country.languages);
                }
            }

            for (const language of selectedLanguage[0]) {
                this.languages.push(language);
            }

            this.formData.language = this.languages[0].value;

            this.dataRow = this.languages.length > 1 ? "2" : "1";
        }
    };

    public setOpenNewsletterDialog() {
        if (this.$route.query.hasOwnProperty("IsNewsletter")) {
            this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
        } else {
            if (!CookieHelper.getCookie("nwsl") && window.localStorage.getItem("countryConfirmed")) {
                setTimeout(x => {
                    this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", true);
                }, 5000);
            }
        }
    }

    public showNewsletterInterests() {
        this.isNewsletterInterestsVisible = !this.isNewsletterInterestsVisible;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("group")) {
            this.formData.defaultGroup = urlParams.get("group");
        }

        try {
            await (<any>window).hcaptcha.execute({ async: true });
            await Axios.post(this.routes.Newsletter_NewsletterSubscribe, this.formData, { headers: { "hCaptchaVerificationToken": (<any>window).hcaptcha.getResponse() } });

            this.isSuccess = true;

            CookieHelper.setCookie("nwsl", "nwsl", 365);

            GTagHelper.sendEvent("form_submit", "newsletter_subscribe");
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        (<any>window).hcaptcha.reset();

        this.isLoading = false;
    }

    public closeNewsletterSubscribe(isSubscibed: boolean) {
        if (!this.isSuccess) {
            CookieHelper.setCookie("nwsl", "nwsl", 30);
        }

        this.$store.commit("newsletterStore/setNewsletterSubscribeVisible", false);
        this.isLoading = false;
        this.isSuccess = false;
        this.newAccount = false;
        this.formData = {
            interests: this.subscribeData.interests.map(x => x.value),
            profileSegment: null
        };
        this.validationErrors = [];

        if (isSubscibed) {
            GTagHelper.sendEvent("click", "newsletter_subscribe", "no_registration");
        }
    }

    public registerNewAccount() {
        GTagHelper.sendEvent("click", "newsletter_subscribe", "registration");
        document.querySelector("#NewsletterRecaptcha").remove();

        this.newAccount = true;
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};